import AppAuth from "@/AppAuth";
import AppErrorBoundary from "./AppErrorBoundary";

export default function AppAuthWithErrorBoundary() {
  return (
    <AppErrorBoundary>
      <AppAuth />
    </AppErrorBoundary>
  );
}
